import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "./AboutUs.css";

export default function AboutUs() {
  const navigate = useNavigate();

  return (
    <>
      <section className="about-banner">
        <div className="banner-overlay">
          <div className="breadcrumb">
            <span onClick={() => navigate("/")}>Home</span> /
            <span className="active"> About Us</span>
          </div>
        </div>
      </section>

      <section className="about-heading">
        <h1>
          <span className="highlight">About AAPS Placements</span>
        </h1>

        <p>
          AAPS Placements is a career-focused training and placement platform
          dedicated to helping students and job seekers build strong technical
          skills and achieve successful careers in the IT industry. We believe
          that the right guidance, practical knowledge, and consistent support
          can transform any learner into an industry-ready professional.
        </p>

        <p>
          Our training programs are designed with a real-time industry approach,
          where students gain hands-on experience through live projects, expert
          mentorship, and structured learning paths. We focus not only on
          technical knowledge but also on improving communication skills,
          problem-solving ability, and interview confidence.
        </p>

        <p>
          At AAPS Placements, we provide complete career support — from learning
          and practice to resume building and placement assistance. Our goal is
          to bridge the gap between education and employment by preparing
          candidates to meet current industry demands and succeed in real-world
          job roles.
        </p>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="why-section">
        <h2>Why Choose Us?</h2>

        <div className="flow-cards">
          <div className="flow-item">Real-time Projects</div>
          <div className="arrow">→</div>
          <div className="flow-item">Expert Trainers</div>
          <div className="arrow">→</div>
          <div className="flow-item">Placement Support</div>
          <div className="arrow">→</div>
          <div className="flow-item">Interview Preparation</div>
        </div>
      </section>

      {/* ===== WHAT WE PROVIDE ===== */}
      <section className="provide-section">
        <h2>What We Provide?</h2>

        <div className="flow-cards">
          <div className="flow-item">Industry Training</div>
          <div className="arrow">→</div>
          <div className="flow-item">Live Classes</div>
          <div className="arrow">→</div>
          <div className="flow-item">Project Guidance</div>
          <div className="arrow">→</div>
          <div className="flow-item">Resume Building</div>
        </div>
      </section>

      {/* ===== VISION & MISSION ===== */}
      <section className="vision-section">
        <div className="vision-grid">
          <div className="vision-card">
            <h3>Our Vision</h3>
            <p>
              To empower students with the right skills and make them
              industry-ready professionals.
            </p>
          </div>

          <div className="vision-card">
            <h3>Our Mission</h3>
            <p>
              To provide quality training, real-time exposure, and ensure
              successful career growth.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
